import { makeStyles } from '@mui/styles'
import { Theme, alpha } from '@mui/material/styles'

export const useImageLabelOverlayStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'relative',
  },
  img: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  imgLabel: {
    position: 'absolute',
    padding: theme.spacing(3),
    bottom: 0,
    left: 0,
    right: 0,
    color: '#fff', // todo - text light in palette?
    backgroundColor: alpha(theme.palette.primary.main, 0.85),
  },
}))
